import styled from 'styled-components';

const Wrapper = styled.div`
  transform: skewY(-5deg);
  padding: 3rem 0;
  height: 100%;
  @media (min-width: 992px) {
    padding: 8rem 0;
  }
  & > * {
    transform: skewY(5deg);
  }
`;

export { Wrapper };
